const FeedbackComponent = ({ s_sts, resources_url }) => {

  const formControl = (e) => {
    e.preventDefault();
    window.alert("Thankyou, your feedback has recieved!");
    setTimeout(() => {
      document.getElementById("user_name").value = '';
      document.getElementById("user_contact").value = '';
      document.getElementById("feedback").value = '';
    }, 3000);
  }

  return (
    <div className={(s_sts==="active") ? "feedback_component active" : "feedback_component"}>
      <section className="feedbacks">
        <h3>Take a minute & give us a feedback</h3>

        <form onSubmit={(e) => formControl(e)}>
          <input type="text" name="user_name" id="user_name" placeholder=" name "/>
          <input type="tel" name="user_contact" id="user_contact" placeholder=" contact "/>
          <label htmlFor="feedback">feedback :</label>
          <textarea name="feedback" id="feedback" cols="30" rows="10"></textarea>
          <button type="submit">submit</button>
        </form>
      </section>
      <section className="downloads">
        <a target="_blank" href={resources_url} rel="noreferrer">
          <button type="button">
            <abbr title="&nbsp;download todays content&nbsp;">&#8659;</abbr>
          </button>
        </a>
      </section>
    </div>
  );
}

export default FeedbackComponent;